import React, { useEffect, useState } from 'react'
import { getOneAddress } from '../../redux/Slices/UserSlice'
import { useDispatch, useSelector } from 'react-redux'
import UseGetAllItemsCart from './UseGetAllItemsCart'
import notify from '../UseNotification'
import { CashOnDelivery, PayByVisa } from '../../redux/Slices/CheckOutSlice'
import { useNavigate } from 'react-router-dom'

const UsePayCach = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [PayMethod, setPayMethod] = useState("")
    const [loading, setLoading] = useState(true)
    const [addressData, setAddressData] = useState([])
    const [addressSelected, setaddressSelected] = useState("0")
    const [orderLoading, setOrderLoading] = useState(true)
    const [VisaOrderLoading, setVisaOrderLoading] = useState(true)
    const { oneAddress } = useSelector(state => state.UserReducer)
    const { cachonDelivery, visaPayment } = useSelector(state => state.CheckOutReducer)
    const [ItemsCartNumber, AllCartItems, CouponNameText, priceAfterDiscount, cartId, TotalPrice] = UseGetAllItemsCart()

    // handle user address
    const handleChangeAddress = async (e) => {
        setaddressSelected(e.target.value)
        if (e.target.value === "0") {
            notify("Please choose which address you will recevie the order", "warn")
            return;
        }
    }

    // handle to get the address details
    const handleAddressDetails = async () => {
        if (addressSelected != "0") {
            setLoading(true)
            await dispatch(getOneAddress(addressSelected))
            setLoading(false)
        }
    }

    // to run get the address details
    useEffect(() => {
        handleAddressDetails()
    }, [addressSelected])


    // run select user address function
    useEffect(() => {
        if (loading === false) {
            if (oneAddress && oneAddress.data)
                setAddressData(oneAddress.data.data)
        }
    }, [loading])

    // handle change payment method function
    const changePaymentMethod = (e) => {
        setPayMethod(e.target.value)
    }

    // handle cash payment method
    const handleCashPaymentMethod = async () => {
        setOrderLoading(true)
        if (addressSelected != "0") {
            await dispatch(CashOnDelivery({
                id: cartId,
                data: {
                    shippingAddress: {
                        "details": addressData.details,
                        "phone": addressData.phone,
                        "city": addressData.city,
                        "postalCode": addressData.postalCode
                    }
                }
            }))
        }
        else {
            notify("Please choose which address you will recevie the order", "warn");
        }
        setOrderLoading(false)
    }

    // handle cash payment method
    const handleCardPaymentMethod = async () => {
        setVisaOrderLoading(true)
            await dispatch(PayByVisa({
                cartId,
                    shippingAddress: {
                        "details": addressData.alias,
                        "phone": addressData.phone,
                        "city": addressData.city,
                        "postalCode": addressData.postalCode
                    }                
            }))

        setVisaOrderLoading(false)
    }
    // when user click on complete the order button
    const handleCompleteOrder = () => {
        if (PayMethod === "Cash") {
            handleCashPaymentMethod()
        }
        else if (PayMethod === "Visa") {
            handleCardPaymentMethod()
        }
        else {
            notify("Please choose a payment method", "warn")
        }
    }

    // handle response of cash order request
    useEffect(() => {
        if (orderLoading === false) {
            if (cachonDelivery.status === 201) {
                notify("order done", "success")
                setTimeout(() => {
                    navigate("/user/allorders")
                }, 1000)
            }
        }
    }, [orderLoading])

    // handle response of visa order
    useEffect(() => {
        if (VisaOrderLoading === false) {
            if (visaPayment && visaPayment.status === "success") {
                if (visaPayment.session?.url){
                    window.open(visaPayment.session.url)
                }
            }else{
                notify("error with payment, Please try after minutes", "error")
            }
        }
    }, [VisaOrderLoading])
    return [handleChangeAddress, handleCompleteOrder, TotalPrice, changePaymentMethod]
}

export default UsePayCach
